<style lang="scss" scoped>
  button {
    cursor: pointer;
  }

  .table th,
  .text-wrap table th {
    color: #9aa0ac;
    text-transform: uppercase;
    font-size: 0.875rem;
    font-weight: 400;
  }
</style>

<template>
  <div>
    <DeviceScan />

    <DeviceCreate
      :plans="plans"
      :root="root"
      v-if="creating"
    />

    <div
      class="card"
      v-else-if="! scanning"
    >
      <div class="card-header">
        {{ __('Integração Whatsapp') }} <small><span class="badge badge-box">BETA</span></small>

        <a
          href="#"
          class="float-right"
          v-b-tooltip="'Temporariamente indisponível'"
          @click.prevent="addDevice()"
          v-if="! devices.length"
        >
          <i class="fa fa-plus" /> {{ __('Adicionar dispositivo') }}
        </a>
      </div>

      <div class="card-body">
        <div class="col-sm-12 col-md-12">
          <div v-if="loading">
            <i class="fa fa-circle-o-notch fa-spin" />
          </div>

          <div v-else>
            <div
              class="mb-4"
              v-if="devices.length"
            >
              <DeviceTable
                :devices="devices"
                :plans="plans"
                :root="root"
              />
            </div>

            <div
              class="text-center mb-4"
              v-else
            >
              <div class="display-4 text-muted mb-3 mt-3">
                <i class="fa fa-mobile" />
              </div>
              <h1 class="h2 mb-3">
                {{ __('Adicione um dispositivo') }}
              </h1>
              <p class="h4 text-muted font-weight-normal d-none">
                {{ __('Caso tenha vários números WhatsApp, você pode criar vários dispositivos') }}
              </p>
              <p class="h4 text-muted font-weight-normal d-none">
                Our elastic platform can scale with your needs.
              </p>
              <div class="m-t-40">
                <a
                  href="#"
                  class="btn btn-box-success"
                  :v-b-tooltip="__('Temporariamente indisponível')"
                  @click.prevent="addDevice()"
                >{{ __('Adicionar dispositivo') }}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { VBTooltip } from 'bootstrap-vue';

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },

  props: {
    root: {
      type: Boolean,
      default: false,
    },
  },

  mounted () {
    Bus.$on('creatingButtonToggle', () => this.creating = ! this.creating);

    Bus.$on('scanningButtonToggle', () => this.scanning = ! this.scanning);

    this.loadDevices();
  },

  data () {
    return {
      plans: {},
      tenant: {},
      devices: [],
      loading: false,
      creating: false,
      scanning: false,
    };
  },

  computed: {
    hasBillingDetails () {
      return this.tenant.address !== null && this.tenant.document !== null;
    },
  },

  methods: {
    getPlans () {
      this.$http.get('/device/plans')
        .then((response) => {
          this.plans = response.data;
        })
        .catch(({ data: error }) => {
          console.error(error);
        });
    },

    loadDevices () {
      this.loading = true;

      this.getPlans();

      this.$http.get('/device')
        .then((response) => {
          this.devices = response.data;

          this.loading = false;
        })
        .catch(() => {
          Alert.error(this.__('Erro ao listar domínios, tente novamente mais tarde.'));
        });
    },

    addDevice () {
      return false;

      this.loading = true;

      this.$http.get('/billing/details')
        .then((response) => {
          this.tenant = response.data.tenant;

          this.loading = false;
        })
        .finally(() => {
          this.hasBillingDetails ? Bus.$emit('creatingButtonToggle') : Bus.$emit('tenantDetail', this.tenant);
        });
    },
  },
};
</script>
